import Axios from "../config/config";

export const CREATE_LEARNER_GROUP = async (body) => {
    try {
        const response = await Axios.post('create-learner-group/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};


export const EDIT_LEARNER_GROUP = async (body) => {
    try {
        const response = await Axios.post('edit-learner-group/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};


export const LIST_LEARNER_GROUP = async (body) => {
    try {
        const response = await Axios.post('list-learner-group/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};

export const VIEW_LEARNER_GROUP = async (body) => {
    try {
        const response = await Axios.post('view-learner-group/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};

export const LEARNER_GROUP_LIST = async (body) => {
    try {
        const response = await Axios.post('learner-list/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};